import React, { useEffect, useState } from "react";
import "./my-deposit-modal.scss";
import DefaultModal from "../DefaultModal";
import { useTranslation } from "react-i18next";
import { API_USER } from "../../../api/user";
import { useSelector } from "react-redux";
import { formatDateTime } from "../../../utils/utils";
import { successToast } from "../../mui/Toaster";
import { ENUM_DEPOSIT_STATUS, TEST_MODE } from "../../../store/enums";
import ShowContainer from "../../mui/ShowContainer";
import useDecimalValue from "../../../hooks/useDecimalValue";
import MyTable from "../../mui/my_table/MyTable";

export default function MyDepositModal({ isOpen, closeModal }) {
  const { t } = useTranslation();
  const getDecimalValue = useDecimalValue();

  const currency = useSelector((state) => state.user.currency);
  const [statusHash, setStatusHash] = useState({});
  const [deposits, setDeposits] = useState([]);
  const [depositLastDays, setDepositLastDays] = useState(0);

  const onCopyClick = (value) => {
    navigator.clipboard.writeText(value);
    successToast(t("successfully copied to clipboard"));
  };

  useEffect(() => {
    if (!isOpen) return;
    if (!currency) return;

    if (TEST_MODE) {
      return;
    }

    API_USER.balance
      .depositList({ currency })
      .then((e) => {
        const data = e.data.data;
        setStatusHash(data.statusList);
        setDeposits(data.depositList);
        setDepositLastDays(data.options.depositLastDays);
        console.log(data);
      })
      .catch(console.log);
  }, [currency, isOpen]);

  const headers = [
    { accessor: "id", label: t("Invoice ID"), width: 100, type: "number" },
    {
      accessor: "dateTime",
      label: t("Date"),
      width: 140,
      type: "string"
    },
    {
      accessor: "refillAmount",
      label: t("Refill Amount"),
      width: "auto",
      type: "string"
    },
    {
      accessor: "status",
      align: "center",
      label: t("Status"),
      width: 110,
      type: "string"
    }
  ];

  const EMPLOYEE_DATA = deposits.map((el) => ({
    id: (
      <div className="copy-invoice pointer" onClick={() => onCopyClick(el.invoiceId)}>
        {el.invoiceId}
      </div>
    ),
    dateTime: formatDateTime(el.dateTime),
    refillAmount: `${getDecimalValue(el.refillAmount, currency)} ${currency}`,
    status: t(ENUM_DEPOSIT_STATUS[statusHash[el.status]])
  }));

  return (
    <DefaultModal isOpen={isOpen} closeModal={closeModal} classModal="my-deposit-modal">
      <h2>{t("Deposit transactions")}</h2>

      <ShowContainer condition={depositLastDays}>
        <p>{t("Shows all deposit requests for the last days.", { depositLastDays })}</p>
      </ShowContainer>

      <div className="table-scroller">
        {isOpen && <MyTable rows={EMPLOYEE_DATA} headers={headers} />}
      </div>
    </DefaultModal>
  );
}
